import { useQuery } from '@tanstack/react-query'

import { errorToast } from 'common/components/toastNotification'

import { getProjectConfig } from '../api'
import { projectKeys } from '../api/queryKeys'

const useProjectConfigQuery = ({
  accountId,
  projectId,
}: {
  accountId: string
  projectId: string
}) => {
  return useQuery({
    queryKey: projectKeys.projectConfig({ accountId, projectId }),

    queryFn: () =>
      getProjectConfig(accountId, projectId).then((res) => res.data.project),
    refetchOnWindowFocus: false,
  })
}

export default useProjectConfigQuery
